import React from 'react';

const ApplicationContext = React.createContext({
  getAttribute: () => {},
  toggleDebugJsonForm: () => {},
  debugJsonForm: false,
  isNavbarCollapsed: false,
  setIsNavbarCollapsed: null,
  buildTimestamp: null,
  setBuildTimestamp: () => {},
});

export default ApplicationContext;
